import React, { useEffect, useState } from "react";
import fetchData from "../../api/fetchApi";
import { useParams, useNavigate } from "react-router-dom";

export default function EditSliderPage() {
  // Image upload handler (copied from CreateSliderPage.js)
  const handleImageUpload = async (e, field = "image_path") => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    try {
      setLoading(true);
      setError(null);
      const res = await fetchData("chaat/files/uploads", "POST", formData, true);
      setForm(f => ({ ...f, [field]: res.data[0].path || "" }));
    } catch (err) {
      setError(err.message || "فشل رفع الصورة");
    } finally {
      setLoading(false);
    }
  };
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    image_path: "",
    image_path_dark: "",
    link: "",
    link_mobile: "",
    order: "",
    is_active: false,
    is_clickable: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const fetchSlider = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchData(`chaat/sliders/${id}`);
        setForm({
          name: data.data.name || "",
          image_path: data.data.image_path || "",
          image_path_dark: data.data.image_path_dark || "",
          link: data.data.link || "",
          link_mobile: data.data.link_mobile || "",
          order: data.data.order ? String(data.data.order) : "",
          is_active: data.data.is_active === 1,
          is_clickable: data.data.is_clickable === 1
        });
      } catch (err) {
        setError(err.message || "حدث خطأ أثناء جلب البيانات");
      } finally {
        setLoading(false);
      }
    };
    fetchSlider();
  }, [id]);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const body = {
        ...form,
        order: Number(form.order),
        is_active: form.is_active ? 1 : 0,
        is_clickable: form.is_clickable ? 1 : 0
      };
      await fetchData(`chaat/sliders/${id}`, "PUT", body);
      setSuccess("تم تحديث السلايدر بنجاح!");
      setTimeout(() => navigate("/admin/sliders"), 1200);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء التحديث");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8 bg-white rounded-3xl shadow-lg border border-gray-100">
      <h2 className="text-2xl font-bold mb-6 text-center text-blue-700">تعديل السلايدر</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-6">
        {/* Basic Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block mb-1 font-semibold text-gray-700">اسم السلايدر<span className="text-red-500">*</span></label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-blue-200"
              placeholder="اسم السلايدر"
              required
            />
          </div>
          <div>
            <label className="block mb-1 font-semibold text-gray-700">رابط الموقع</label>
            <input
              name="link"
              value={form.link}
              onChange={handleChange}
              className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-blue-200"
              placeholder="رابط الموقع"
            />
          </div>
        </div>
        {/* Image Uploads */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-gray-50 rounded-xl p-4 flex flex-col items-center border border-gray-200">
            <label className="block mb-2 font-semibold text-gray-700">صورة السلايدر<span className="text-red-500">*</span></label>
            <input
              type="file"
              accept="image/*"
              onChange={e => handleImageUpload(e, "image_path")}
              className="mb-2 file:mr-2 file:py-1 file:px-3 file:rounded file:border file:border-gray-300"
            />
            {form.image_path && (
              <img src={form.image_path} alt="الصورة" className="rounded shadow mb-2" style={{ maxWidth: 140, maxHeight: 100 }} />
            )}
            <input
              name="image_path"
              value={form.image_path}
              onChange={handleChange}
              className="border border-gray-300 rounded-lg px-3 py-2 w-full mt-1 focus:ring-2 focus:ring-blue-200"
              placeholder="رابط الصورة"
              required
            />
            {form.image_path && (
              <div className="mt-1 text-xs text-blue-600 break-all text-center">
                <a href={form.image_path} target="_blank" rel="noopener noreferrer">{form.image_path}</a>
              </div>
            )}
          </div>
          <div className="bg-gray-50 rounded-xl p-4 flex flex-col items-center border border-gray-200">
            <label className="block mb-2 font-semibold text-gray-700">صورة الوضع الداكن</label>
            <input
              type="file"
              accept="image/*"
              onChange={e => handleImageUpload(e, "image_path_dark")}
              className="mb-2 file:mr-2 file:py-1 file:px-3 file:rounded file:border file:border-gray-300"
            />
            {form.image_path_dark && (
              <img src={form.image_path_dark} alt="الصورة الداكنة" className="rounded shadow mb-2" style={{ maxWidth: 140, maxHeight: 100 }} />
            )}
            <input
              name="image_path_dark"
              value={form.image_path_dark}
              onChange={handleChange}
              className="border border-gray-300 rounded-lg px-3 py-2 w-full mt-1 focus:ring-2 focus:ring-blue-200"
              placeholder="رابط الصورة (الوضع الداكن)"
            />
            {form.image_path_dark && (
              <div className="mt-1 text-xs text-blue-600 break-all text-center">
                <a href={form.image_path_dark} target="_blank" rel="noopener noreferrer">{form.image_path_dark}</a>
              </div>
            )}
          </div>
        </div>
        {/* Other Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block mb-1 font-semibold text-gray-700">رابط الموبايل</label>
            <input
              name="link_mobile"
              value={form.link_mobile}
              onChange={handleChange}
              className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-blue-200"
              placeholder="رابط الموبايل"
            />
          </div>
          <div>
            <label className="block mb-1 font-semibold text-gray-700">الترتيب<span className="text-red-500">*</span></label>
            <input
              name="order"
              value={form.order}
              onChange={handleChange}
              className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-blue-200"
              placeholder="الترتيب"
              type="number"
              required
            />
          </div>
        </div>
        {/* Switches */}
        <div className="flex gap-8 items-center justify-center mt-2">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              name="is_active"
              checked={form.is_active}
              onChange={handleChange}
              className="accent-blue-600 w-5 h-5"
            />
            <span className="font-medium text-gray-700">نشط</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              name="is_clickable"
              checked={form.is_clickable}
              onChange={handleChange}
              className="accent-blue-600 w-5 h-5"
            />
            <span className="font-medium text-gray-700">قابل للنقر</span>
          </label>
        </div>
        <button
          type="submit"
          className="bg-gradient-to-l from-blue-700 to-blue-500 hover:from-blue-800 hover:to-blue-600 text-white px-8 py-3 rounded-xl shadow-lg font-bold text-lg transition-all duration-200 mt-4"
          disabled={loading}
        >
          {loading ? "جاري التحديث..." : "تحديث"}
        </button>
        {error && <div className="text-red-600 text-sm text-center mt-2">{error}</div>}
        {success && <div className="text-green-600 text-sm text-center mt-2">{success}</div>}
      </form>
    </div>
  );
}
